<template>
  <div>
    <div class="row">
      <a-divider>{{ $t('etablissement.fraisParJour') }}</a-divider>

      <div class="col-lg-6" v-if="activity.inscription && activity.inscription !== 0">
        <h6>{{ $t("inscription.fraisInscri") + " (" + currency + ")" }}</h6>
        <p>{{ activity.inscription }}</p>
      </div>
      <div class="col-lg-6">
        <h6>{{ $t('etablissement.fraisParJour') + " (" + currency + ")" }}</h6>
        <p>{{ activity.monthly }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <DailyCalendar
          :selected-dates="selectedDates"
          :activity-start="activityStart"
          :activity-end="activityEnd"
          @add-date="(date) => $emit('add-date', date)"
          @remove-date="(date) => $emit('remove-date', date)"
          @clear-all-dates="$emit('clear-all-dates')"
        />
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import DailyCalendar from "@/components/comptabilite/DailyCalendar.vue";
import { getBuildingCurrency } from "@/utilities/countrySpecific";

export default {
  name: "DailyFeesSection",
  components: {
    DailyCalendar,
  },
  props: {
    activity: {
      type: Object,
      default: () => ({}),
    },
    selectedDates: {
      type: Array,
      default: () => [],
    },
    activityStart: {
      type: Object,
      default: null,
    },
    activityEnd: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currency: getBuildingCurrency(),
    };
  },
};
</script>
